const dateFormatter = {
  toChinese: (dateString, formatter) => {
    let needDate = dateFormatter.getDate(dateString)
    return formatter.replace('%Y', needDate.getFullYear())
      .replace('%M', ('00' + (needDate.getMonth()+1)).slice(-2))
      .replace('%D', ('00' + needDate.getDate()).slice(-2))
  },
  getDate: (dateString) => {
    return new Date(dateString.replace(/-/g, '/'))
  }
}

export default dateFormatter



// WEBPACK FOOTER //
// ./src/utils/date.js